import { Button, Form, Input, Modal, Space, Typography } from "antd";
import axios from "axios";
import React, { useContext } from "react";
import { NotificationInfo, UserInfo } from "../../../context";

const EditContact = ({ open, close, data, rerun }) => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);

  const handleUpdateContact = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    axios
      .post("user/store-admin/update-contact", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Updated contact successfully.");
          setTimeout(() => {
            close();
            rerun();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
      centered
    >
      <Form
        layout="vertical"
        name="edit-contact2"
        initialValues={{
          contact_no: data.contact_no,
          email: data.storeadminuser.email,
        }}
        onFinish={handleUpdateContact}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="contact_no"
            label="Contact No."
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input placeholder="Set contact" size="large" />
          </Form.Item>

          <Form.Item
            name="email"
            label="Email"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Input
              placeholder="Set email"
              size="large"
              disabled={data.storeadminuser.email !== null ? true : false}
            />
          </Form.Item>
          {data.storeadminuser.email !== null && (
            <Typography style={{ color: "red" }}>
              Email can't be changed!
            </Typography>
          )}
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Update
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default EditContact;
